import { Injectable } from '@angular/core';
import { HttpWrapperService } from '../common/http-wrapper/http-wrapper.service';
import { Observable } from 'rxjs';

import { AccountModel } from '../../models/AccountModel';

@Injectable()
export class AccountApiService {
    constructor(private httpService: HttpWrapperService ) { }

    public getAccount(accountId: number): Observable<AccountModel> {
        return this.httpService.get<AccountModel>(`/accounts/${accountId}`);
    }
}

